import { render, staticRenderFns } from "./DemoSelect.vue?vue&type=template&id=1fe536b5&scoped=true&"
import script from "./DemoSelect.vue?vue&type=script&lang=js&"
export * from "./DemoSelect.vue?vue&type=script&lang=js&"
import style0 from "./DemoSelect.vue?vue&type=style&index=0&id=1fe536b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe536b5",
  null
  
)

export default component.exports